import { render, staticRenderFns } from "./Escort.vue?vue&type=template&id=12af14fc&scoped=true"
import script from "./Escort.vue?vue&type=script&lang=js"
export * from "./Escort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af14fc",
  null
  
)

export default component.exports